import React from 'react'
import AlertTips from 'pureComponents/AlertTips'
import DialogInputLabel from 'pureComponents/DialogInputLabel'
import { getWarningMsg } from '../UploadChannelPkg/utils'
import useUploadConfirm from './hooks/useUploadConfirm'

// 操作结果页面
const UploadConfirm = props => {
    const { dialogType } = props
    const { genExistFileComponent, genNotExistFileComponent, existLength, notExistLength } = useUploadConfirm(props)

    return (
        <div>
            <div className="track-body-item" key="info_1">
                <AlertTips type="warn">{getWarningMsg(dialogType, existLength, notExistLength)}</AlertTips>
            </div>
            {dialogType === 'multiReplace' && notExistLength > 0 ? (
                <div className="track-body-item" key="info_3">
                    <DialogInputLabel className="track-body-title-bold" label="匹配失败的渠道包" />
                    {genNotExistFileComponent()}
                </div>
            ) : null}
            {existLength > 0 ? (
                <div className="track-body-item" key="info_2">
                    <DialogInputLabel
                        className="track-body-title-bold"
                        label={dialogType === 'multiUpload' ? '名称重复的渠道包' : '匹配成功的渠道包'}
                    />
                    {genExistFileComponent()}
                </div>
            ) : null}
        </div>
    )
}

export default UploadConfirm
